import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { UserSourcesListSkeleton } from "@/app/user-sources/components/user-sources-list-skeleton";
import { UserSourcesList } from "@/app/user-sources/list";
import {
  userSourcesSearchDefaults,
  userSourcesSearchSchema,
} from "@/app/user-sources/search-params";
import { requireProjectPermission } from "@/lib/route-guards";

function UserSourcesPage() {
  return (
    <Suspense fallback={<UserSourcesListSkeleton />}>
      <UserSourcesList />
    </Suspense>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/user-sources"
)({
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.userSources.read),
  validateSearch: userSourcesSearchSchema,
  search: {
    middlewares: [stripSearchParams(userSourcesSearchDefaults)],
  },
  component: UserSourcesPage,
  loader: () => ({
    crumb: "User sources",
  }),
});
